import React from "react";
import { BookOpen } from "lucide-react";

export const PrimerPanel = () => (
  <div
    className="rounded-xl border border-white/10 bg-gradient-to-br from-[#0d1326] to-[#070710] p-5 mb-6"
    data-testid="analysis-primer"
  >
    <div className="flex items-center gap-2 mb-3">
      <BookOpen className="w-4 h-4 text-[#3FE5DC]" />
      <span className="text-[10px] uppercase tracking-[0.22em] text-[#3FE5DC]">
        How to read this page
      </span>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-[12px] text-white/70 leading-snug">
      <div>
        <div className="text-white/90 font-medium mb-1">🔥 Heatmap</div>
        Sectors row shows the day's bid/offer rotation. The mover grid below ranks the biggest
        single-name moves — momentum + crowd attention.
      </div>
      <div>
        <div className="text-white/90 font-medium mb-1">📊 Technicals</div>
        RSI &gt;70 = stretched; &lt;30 = washed out. MACD crossover = trend change. Watch SMA200 as
        a regime line — above = up-trend.
      </div>
      <div>
        <div className="text-white/90 font-medium mb-1">🎯 S/R + Options</div>
        Support/resistance levels come from pivot clusters. Put/call ratio &gt;1 = bearish hedging;
        high call OI strikes act as magnets / walls.
      </div>
    </div>
  </div>
);
